// extracted by mini-css-extract-plugin
export default {"title":"Title_title__bYnT4","sunken":"Title_sunken__MbwAD"};